import { CellProperties } from "handsontable/settings";

export interface MatrixInputCellFeedbackProperties extends CellProperties {
  validationError?: string;
  cellSaveState?: {
    errorInfo?: {
      errorMessage?: string;
    };
  };
}

export const applyMatrixInputCellFeedback = (td: HTMLTableCellElement, cellProperties: CellProperties) => {
  const feedbackProperties = cellProperties as MatrixInputCellFeedbackProperties;
  const errorMessage = feedbackProperties.validationError || feedbackProperties.cellSaveState?.errorInfo?.errorMessage;

  if (errorMessage) {
    td.style.backgroundColor = "rgba(244, 67, 54, 0.08)";
    td.style.boxShadow = "inset 0 0 0 1px #f44336";
    td.setAttribute("title", errorMessage);
    td.setAttribute("aria-invalid", "true");
  } else {
    td.style.backgroundColor = "";
    td.style.boxShadow = "";
    td.removeAttribute("title");
    td.removeAttribute("aria-invalid");
  }
};

export default applyMatrixInputCellFeedback;
